import { SET_GEOFENCE_DATA, SET_TOTAL_GEOFENCES, SET_GEOFENCE_CURRENT_PAGE, SET_GEOFENCE_PAGE_SIZE, REMOVE_GEOFENCES } from "../types"

export const setGeofencesData = (data) => ({
    type: SET_GEOFENCE_DATA,
    payload: data,
})

export const setTotalGeofences = (total) => ({
    type: SET_TOTAL_GEOFENCES,
    payload: total,
})

export const setGeofencePage = (page) => ({
    type: SET_GEOFENCE_CURRENT_PAGE,
    payload: page,
})

export const setGeofencePageSize = (size) => ({
    type: SET_GEOFENCE_PAGE_SIZE,
    payload: size,
})

export const removeGeofences = () => {
    return {
        type: REMOVE_GEOFENCES
    }
}